<template>
  <div>
    <usertop />

    <van-tabs v-model="active" @click="getData">
      <van-tab title="我的租房">
        <div>
          <div class="adminhouse">
            <ul>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :immediate-check="false"
              >
                <li v-for="(item,index) in lists" :key="index">
                  <div class="litop">
                    <div class="img" @click="$router.push('/zufang/view/'+item.id)">
                      <div class="top" v-if="item.stick"></div>
                      <div class="bottom" v-if="item.isagent">中介</div>
                      <img :src="item.thumbnail" />
                    </div>
                    <div class="info">
                      <h1 @click="$router.push('/zufang/view/'+item.id)">{{item.title}}</h1>
                      <p class="txt2">刷新时间：{{item.refreshtime_cn}}</p>
                      <p class="tag">
                        <van-tag
                          color="#ecf3fe"
                          text-color="#6e86b1"
                          v-for="(v,i) in item.tese"
                          :key="i"
                        >{{v}}</van-tag>
                      </p>
                      <p class="txt1">{{item.price}}元/月</p>
                    </div>
                  </div>
                  <p class="litopbtn">
                    <van-button type="info" size="small" block @click="refresh(item.id,'zufang')">刷新</van-button>
                    <van-button
                      type="primary"
                      size="small"
                      block
                      @click="$router.push('/user/sticky/'+item.id)"
                    >置顶</van-button>
                     <van-button
                      block
                      type="warning"
                      size="small"
                      @click="del(item.id,index,'zufang')"
                    >关闭</van-button>
                    <van-button
                      block
                      type="danger"
                      size="small"
                      @click="del(item.id,index,'zufang')"
                    >删除</van-button>
                  </p>
                </li>
              </van-list>
            </ul>
          </div>
        </div>
      </van-tab>
      <van-tab title="我的二手房">
        <div>
          <div class="adminhouse">
            <ul>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :immediate-check="false"
              >
                <li v-for="(item,index) in lists" :key="index">
                  <div class="litop">
                    <div class="img" @click="$router.push('/ershoufang/view/'+item.id)">
                      <div class="top" v-if="item.stick"></div>
                      <div class="bottom" v-if="item.isagent">中介</div>
                      <img :src="item.thumbnail" />
                    </div>
                    <div class="info">
                      <h1 @click="$router.push('/ershoufang/view/'+item.id)">{{item.title}}</h1>
                      <p class="txt2">刷新时间：{{item.refreshtime_cn}}</p>
                      <p class="tag">
                        <van-tag
                          color="#ecf3fe"
                          text-color="#6e86b1"
                          v-for="(v,i) in item.tese"
                          :key="i"
                        >{{v}}</van-tag>
                      </p>
                      <p class="txt1">{{item.price}}万元</p>
                    </div>
                  </div>
                  <p class="litopbtn">
                    <van-button type="info" block size="small" @click="refresh(item.id,'ershoufang')">刷新</van-button>
                    <van-button
                      type="primary"
                      size="small"
                      block
                      @click="$router.push('/user/sticky/'+item.id)"
                    >置顶</van-button>
                       <van-button
                      type="warning"
                      size="small"
                      block
                      @click="del(item.id,index,'ershoufang')"
                    >关闭</van-button>
                    <van-button
                      type="danger"
                      size="small"
                      block
                      @click="del(item.id,index,'ershoufang')"
                    >删除</van-button>
                  </p>
                </li>
              </van-list>
            </ul>
          </div>
        </div>
      </van-tab>
      <van-tab title="我的商铺">
        <div>
          <div class="adminhouse">
            <ul>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :immediate-check="false"
              >
                <li v-for="(item,index) in lists" :key="index">
                  <div class="litop">
                    <div class="img" @click="$router.push('/ershoufang/view/'+item.id)">
                      <div class="top" v-if="item.stick"></div>
                      <div class="bottom" v-if="item.isagent">中介</div>
                      <img :src="item.thumbnail" />
                    </div>
                    <div class="info">
                      <h1 @click="$router.push('/ershoufang/view/'+item.id)">{{item.title}}</h1>
                      <p class="txt2">刷新时间：{{item.refreshtime_cn}}</p>
                      <p class="tag">
                        <van-tag
                          color="#ecf3fe"
                          text-color="#6e86b1"
                          v-for="(v,i) in item.tese"
                          :key="i"
                        >{{v}}</van-tag>
                      </p>
                      <p class="txt1">{{item.price}}万元</p>
                    </div>
                  </div>
                  <p class="litopbtn">
                    <van-button type="info" size="small" block @click="refresh(item.id,'ershoufang')">刷新</van-button>
                    <van-button
                      type="primary"
                      size="small"
                      block
                      @click="$router.push('/user/sticky/'+item.id)"
                    >置顶</van-button>
                        <van-button
                      type="warning"
                      size="small"
                      block
                      @click="del(item.id,index,'ershoufang')"
                    >关闭</van-button>
                    <van-button
                      type="danger"
                      size="small"
                      block
                      @click="del(item.id,index,'ershoufang')"
                    >删除</van-button>
                  </p>
                </li>
              </van-list>
            </ul>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <footbar />
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;
import Selectree from "../commpents/selectree";
import Footbar from "../commpents/footbar";
import Usertop from "../commpents/usertop";
import {
  Toast,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  Tag,
  List,
  Icon,
  Button,
  Dialog,
  Tab,
  Tabs,
  Row,
  Col
} from "vant";

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Tag.name]: Tag,
    [List.name]: List,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Row.name]: Row,
    [Col.name]: Col,
    Selectree,
    Footbar,
    Usertop
  },

  data() {
    return {
      getInitUrl: root + "user/fangyuan",
      getRefreshUrl: root + "user/refresh",
      getStickyUrl: root + "user/sticky",
      getDelUrl: root + "user/delpost",
      value: 0,
      type: "zufang",
      page: 1,
      lists: [],
      total: 0,
      loading: false,
      finished: false,
      active: 0
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { page: self.page, type: self.type },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          var lists = reponseData.data.lists;
          console.log(lists);
          self.loading = false;
          self.total = reponseData.data.total;
          for (var i in lists) {
            self.lists.push(lists[i]);
          }
          self.page++;
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    getData(name, title) {
      this.page = 1;
      this.lists = [];
      this.finished = false;

      if (this.active == 0) {
        this.type = "zufang";
      }
      if (this.active == 1) {
        this.type = "ershoufang";
      }
      if (this.active == 2) {
        this.type = "shop";
      }
      this.init();
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        if (this.page >= this.total) {
          this.finished = true;
          return;
        }
        this.loading = true;
        this.init();
      }, 500);
    },
    refresh(id, type) {
      var self = this;
      $.ajax({
        url: self.getRefreshUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { id: id, type: type },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.$toast(reponseData.message);
          if (reponseData.status == 0) {
            self.$router.push("/user/refresh/" + id);
          }
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    sticky(id, type) {
      var self = this;
      $.ajax({
        url: self.getStickyUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { id: id, type: type },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.$toast(reponseData.message);
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    del(id, index, type) {
      var self = this;
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要删除这条信息吗"
        })
        .then(() => {
          $.ajax({
            url: self.getDelUrl,
            timeout: 120000,
            dataType: "json",
            type: "get",
            data: { id: id, type: type },
            headers: self.getRequestHeader(),
            success: function(reponseData, status) {
              self.$toast(reponseData.message);
              if (reponseData.status == 1) {
                self.lists.splice(index, 1);
              }
            },
            error: function() {
              self.$toast("system error");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style scoped>
.user {
  background-color: #3072f6;
  display: flex;
  padding: 30px 25px;
  color: #fff;
}
.avatar-img {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-img img {
  width: 80%;
}
.avatar-info {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-info h1 {
  font-size: 18px;
}
.avatar-info p {
  font-size: 14px;
  color: #fff;
  padding: 4px 0;
}
.user-tag {
  text-align: center;
  padding: 15px 0;
}
.user-tag img {
  width: 40px;
}
.user-tag h1 {
  margin-top: 6px;
  font-size: 14px;
  font-weight: normal;
  color: #555;
}
.user-logout {
  text-align: center;
  padding: 15px;
  margin: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
}
</style>>



